import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { changeBookedStatementPaymentVolume } from '../../../services/customer/ticketBookingServices';

function useChangePaymentVolume({ query }) {
  const navigate = useNavigate();

  const changeVolume = async () => {
    const guid = query.get('guid');
    let statement = sessionStorage.getItem(guid);
    if (!statement) {
      navigate('/ka/profile?tab=booked-statements');
    } else {
      statement = JSON.parse(statement);
      if (!statement?.invoice) {
        const res = await changeBookedStatementPaymentVolume({
          statementId: statement.id,
          guid,
          paymentVolumeId: statement.paymentVolume,
        });
        if (!res.id) {
          navigate('/ka/profile?tab=booked-statements');
        }
      }
    }
  };

  useEffect(() => {
    if (query.get('seatFormation') === 'completeBooking') {
      changeVolume();
    }
  }, []);
}

export default useChangePaymentVolume;
